"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalStorageKey = exports.useLocalStorage = exports.getLocalStorageByKey = exports.LocalStorageKeys = exports.GG_ISSUES_SLICE = void 0;
var React = _interopRequireWildcard(require("react"));
var _alloyProvider = require("@adsk/alloy-provider");
var _alloyHooks = require("../utils/hooks/alloyHooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// if we need to make breaking changes to localstorage, we can update this key
const GG_ISSUES_SLICE = exports.GG_ISSUES_SLICE = "GG_ISSUES_SLICE_V4";
let LocalStorageKeys = exports.LocalStorageKeys = /*#__PURE__*/function (LocalStorageKeys) {
  LocalStorageKeys["OPEN_TYPE_CATEGORIES"] = "OPEN_TYPE_CATEGORIES";
  LocalStorageKeys["OPEN_ROOT_CAUSE_CATEGORIES"] = "OPEN_ROOT_CAUSE_CATEGORIES";
  LocalStorageKeys["LAST_SELECTED_TYPE_ID"] = "LAST_SELECTED_TYPE_ID";
  LocalStorageKeys["ISSUE_LOG_COLUMN_SETTINGS"] = "ISSUE_LOG_COLUMN_SETTINGS";
  LocalStorageKeys["LAST_ISSUE_LOG_QUERY_PARAMS"] = "LAST_ISSUE_LOG_QUERY_PARAMS";
  LocalStorageKeys["LAST_SELECTED_TOOLBAR_TYPE_IDS"] = "LAST_SELECTED_TOOLBAR_TYPE_IDS";
  LocalStorageKeys["LAST_SELECTED_TOOLBAR_SELECTOR_TAB"] = "LAST_SELECTED_TOOLBAR_SELECTOR_TAB";
  LocalStorageKeys["LAST_SELECTED_TEMPLATE_IDS"] = "LAST_SELECTED_TEMPLATE_IDS";
  return LocalStorageKeys;
}({}); // from bim360 issues-ui
const getLocalStorageByKey = key => {
  let data;
  try {
    data = window.localStorage.getItem(key);
    if (data !== null) {
      data = JSON.parse(data);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    data = null;
  }
  return data;
};
exports.getLocalStorageByKey = getLocalStorageByKey;
const useLocalStorageKey = key => {
  const FALLBACK_OXYGEN_ID = "NO_OXYGEN_ID";
  // projectId or oxygenId may be undefined, but this only happens when the service cannot
  // fetch the info or the alloy provider has not been given any project info.
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  const {
    user
  } = (0, _alloyHooks.useUser)();
  const oxygenId = user && user.autodeskId || FALLBACK_OXYGEN_ID;
  if (!projectId || oxygenId === FALLBACK_OXYGEN_ID) {
    // if we try to use the local storage key before we load the user and project we will see this error.
    // ...using this hook before these values have been loaded is bad and will cause problems,
    // so although we don't crash the app we do want to alert devs about this.
    // eslint-disable-next-line no-console
    console.error("Localstorage key for ".concat(key, " could not be determined. This is a problem and should be investigated. projectId: ").concat(projectId, ", oxygenId: ").concat(oxygenId));
  }
  return "".concat(GG_ISSUES_SLICE, "_").concat(projectId, "_").concat(oxygenId, "_").concat(key);
};

/**
 * Determines whether an error is a QuotaExceededError.
 *
 * Browsers love throwing slightly different variations of QuotaExceededError
 * (this is especially true for old browsers/versions), so we need to check
 * different fields and values to ensure we cover every edge-case.
 *
 * @param err - The error to check
 * @return Is the error a QuotaExceededError?
 */
exports.useLocalStorageKey = useLocalStorageKey;
const isQuotaExceededError = err => {
  return err instanceof DOMException && (
  // everything except Firefox
  err.code === 22 ||
  // Firefox
  err.code === 1014 ||
  // test name field too, because code might not be present
  // everything except Firefox
  err.name === "QuotaExceededError" ||
  // Firefox
  err.name === "NS_ERROR_DOM_QUOTA_REACHED");
};
const useLocalStorage = key => {
  const localStorageKey = useLocalStorageKey(key);
  const getLocalStorageValue = React.useCallback(() => {
    return getLocalStorageByKey(localStorageKey);
  }, [localStorageKey]);
  const setLocalStorageValue = React.useCallback(newLocalStorageValue => {
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(newLocalStorageValue));
    } catch (e) {
      if (isQuotaExceededError(e)) {
        // Handle the case where there wasn't enough space to store the
        // item in localStorage.
        console.log("Local storage length", localStorage.length);
      }
      console.error(e);
    }
  }, [localStorageKey]);
  return [getLocalStorageValue, setLocalStorageValue];
};
exports.useLocalStorage = useLocalStorage;
//# sourceMappingURL=useLocalStorage.js.map